import React, { useEffect, useState } from "react";
import "./Self_Service_tabs.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppSetup } from "../../../features/admin/common/Slice";
import Change_Passoword_Modal from "../Change_Passoword_Modal/Change_Passoword_Modal";

function Self_Service_tabs() {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const appSetup = useSelector((state) => state.common.app_setup);
  useEffect(() => {
    dispatch(AppSetup());
  }, [dispatch]);

  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const menuItems = [
    {
      title: "Deposit Not Received",
      img: "/assets/images/Self_Service_Center/tab_icons/wallet.png",
      linkText: "/deposit-not-received",
    },
    {
      title: "Withdrawal Problem",
      img: "/assets/images/Self_Service_Center/tab_icons/withdraw.png",
      linkText: "/withdrawal-problem-list",
    },
    {
      title: "IFSC Modification",
      img: "/assets/images/Self_Service_Center/tab_icons/IFSC.png",
      linkText: "/ifsc-modification",
    },
    {
      title: "Change Login Password",
      img: "/assets/images/Self_Service_Center/tab_icons/key.png",
      linkText: "/change-login-password",
    },
    {
      title: "Change Bank Name",
      img: "/assets/images/Self_Service_Center/tab_icons/banking.png",
      linkText: "/change-bank-name",
    },
    {
      title: "Modify Bank Information",
      img: "/assets/images/Self_Service_Center/tab_icons/bank.png",
      linkText: "/modify-bank-information",
    },
    {
      title: "Modify UPI",
      img: "/assets/images/Self_Service_Center/tab_icons/upi.png",
      linkText: "/modify-upi",
    },
    {
      title: "Add USDT Address",
      img: "/assets/images/Self_Service_Center/tab_icons/usdt.png",
      linkText: "/add-usdt-address",
    },
    {
      title: "Change USDT Address",
      img: "/assets/images/Self_Service_Center/tab_icons/address.png",
      linkText: "/change-usdt-address",
    },
    {
      title: "Activity Bonus",
      img: "/assets/images/Self_Service_Center/tab_icons/surpise.png",
      linkText: "/activity-bonus",
    },
    {
      title: "Money King Official Website",
      img: "/assets/images/Self_Service_Center/tab_icons/website.png",
      linkText: `${appSetup?.official_website}`,
    },
    {
      title: "Find Teacher",
      img: "/assets/images/Self_Service_Center/tab_icons/teacher.png",
      linkText: `${appSetup?.official_teacher}`,
    },
    {
      title: "Money King Official Channel",
      img: "/assets/images/Self_Service_Center/tab_icons/telegram.png",
      linkText: `${appSetup?.official_telegram}`,
    },
  ];

  // Function to handle navigation
  const handleNavigate = (link) => {
    if (!link) return;

    // Check if it's an external link
    if (/^https?:\/\//.test(link)) {
      window.open(link, "_blank", "noopener,noreferrer");
    } else {
      navigate(link);
    }
  };

  return (
    <section className="Self_Service_tabs">
      <div className="self_service_container">
        <h3 className="self_service_title">Self Service</h3>

        <div className="self_service_card">
          {menuItems.map((item, index) => (
            <div
              className="self_service_row"
              key={index}
              onClick={() => {
                if (item.linkText === "/forgot-password") {
                  setShowPasswordModal(true);
                } else {
                  handleNavigate(item.linkText);
                }
              }}
              style={{ cursor: "pointer" }}
            >
              <div className="left_section">
                <div className="img_holder">
                  <img src={item.img} alt={item.title} className="img_icon" />
                </div>
                <span>{item.title}</span>
              </div>

              <FontAwesomeIcon icon={faChevronRight} className="arrow_icon" />
            </div>
          ))}
        </div>

        <div className="kind_tips">
          <h4>Kind Tips</h4>
          <p>
            1. Please select the corresponding question & submit it for review.
            After successful submission, the customer service specialist will
            handle it for you immediately. Please wait patiently.
          </p>
          <p>
            2. After submitting for review, you can use [Progress Query] to view
            the review results of the work order you submitted.
          </p>
        </div>

        <button
          className="btn_register_bg"
          onClick={() => navigate("/progress-query")}
        >
          Progress Query
        </button>
      </div>

      <Change_Passoword_Modal
        show={showPasswordModal}
        onHide={() => setShowPasswordModal(false)}
      />
    </section>
  );
}

export default Self_Service_tabs;
